import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ProjectsPage.css';

const PROJECTS = [
  { id: 'cls-dk', brand: 'CLS', label: 'CLS Clothing', country: 'DK', flag: '🇩🇰' },
  { id: 'cls-se', brand: 'CLS', label: 'CLS Clothing', country: 'SE', flag: '🇸🇪' },
  { id: 'cls-fi', brand: 'CLS', label: 'CLS Clothing', country: 'FI', flag: '🇫🇮' },
  { id: 'abc-se', brand: 'ABC', label: 'ABC Clothing', country: 'SE', flag: '🇸🇪' },
];

const ProjectsPage = () => {
  const navigate = useNavigate();

  const handleProjectClick = (project) => {
    if (project.id === 'cls-dk') {
      navigate('/clothing/cls-dk');
    } else if (project.id === 'cls-se') {
      navigate('/clothing/cls-se');
    } else if (project.id === 'cls-fi') {
      navigate('/clothing/cls-fi');
    } else if (project.id === 'abc-se') {
      navigate('/clothing/abc-se');
    } else {
      navigate('/design-system');
    }
  };

  return (
    <div className="projects-page">
      <div className="projects-page__inner">
        <h1 className="projects-page__title typo-h1">Projects</h1>
        <p className="projects-page__subtitle typo-body">Select a project to open</p>

        <div className="projects-page__grid">
          {PROJECTS.map((project) => (
            <button
              key={project.id}
              className="projects-page__card"
              onClick={() => handleProjectClick(project)}
            >
              <span className="projects-page__flag">{project.flag}</span>
              <span className="projects-page__card-label typo-h4">{project.label}</span>
              <span className="projects-page__card-country typo-body-sm">{project.country}</span>
            </button>
          ))}
        </div>

        <Link to="/design-system" className="projects-page__ds-link typo-link">
          Design System
        </Link>
        {/* Separate apps since the apps/* split: served at /<app> on the droplets
            (fe1487.clseifert.com/overall …); locally set REACT_APP_*_URL (see .env.dev). */}
        <a href={process.env.REACT_APP_AUTOMATION_HUB_URL || '/automation-hub/'} className="projects-page__ds-link typo-link">
          Automation Hub
        </a>
        <a href={process.env.REACT_APP_OVERALL_URL || '/overall/'} className="projects-page__ds-link typo-link">
          OVER/LL
        </a>
        <a href={process.env.REACT_APP_ABC_DK_URL || '/abc-dk/'} className="projects-page__ds-link typo-link">
          ABC Studenterhuer
        </a>
      </div>
    </div>
  );
};

export default ProjectsPage;
